module.exports = __webpack_public_path__ + "static/media/Druid_Feral_DPS.f7d5c5ed.png";